import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { screeningAction } from '../../actions/constant';
import screeningService from '../../../services/apiServices/screeningDetails/screeningDetails';
const {
  GET_SCREENING_REQUEST,
  GET_SCREENING_SUCCESS,
  GET_SCREENING_FAILURE,
  GET_SCREENING_LOADER,
} = screeningAction;

function* getScreeningRecord(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_SCREENING_LOADER });
    const response = yield call(screeningService.getScreening, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_SCREENING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_SCREENING_FAILURE, payload: error });
  }
}

function* getScreeningSaga() {
  yield takeEvery(GET_SCREENING_REQUEST, getScreeningRecord);
}

export default getScreeningSaga;
